"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const TagListDisplay = ({ tags }) => {
    return (React.createElement("div", { style: {
            maxWidth: 200,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        } }, tags.map((tag, index) => (React.createElement(src_1.Pill, { value: tag, key: index, style: {
            marginRight: 4,
            background: src_1.cloud,
        }, textColor: src_1.black })))));
};
exports.default = TagListDisplay;
